export default __webpack_public_path__ + "static/media/added.6e524785.svg";